import styled from 'styled-components';
import { FiraSansBold } from 'components/Text/Text';
import { Breakpoints } from 'constants/Breakpoints';
import { mediaHelperMaxWidth } from "@fitinsur/utils/src";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;


export const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  justify-content:space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 15px;
    width: 100%;
  }
`;

export const RefreshButon = styled.button`
  display: flex;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: flex-end;
  margin: 0px;
  padding: 0;
  margin-bottom: 5px;
  margin-right: 3px;
`;

export const IconButton = styled.button`
  display: flex;
  width: 50px;
  height: 50px;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: flex-end;
  margin: 0px;
  padding: 0;
  margin-bottom: 20px;
`;

export const ModalityRowContainer = styled.div`
  display: flex;
  align-items: center;
  justifyContent: space-between;
`;

export const ModalityRowTitle = styled.p`
  color: #53565A;
  font-size: 13px;
  font-weight: 700;
  ${({ maxWidth }) => maxWidth ? `max-width: ${maxWidth}` : ''};
`;

export const ModalityBottomSeparatorLine = styled.div`
  width: 100%;
  border-bottom: solid 1px #53565A;
`;

export const TagInput = styled.input`
  flex: 1;
  display:none;
  border: none;
  width:100%;
  
  &:focus {
      outline: transparent;
  }
`;

export const PlaceHolder = styled.label`
  display: block;
  padding: .75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 44px;
  width: auto;
  white-space: nowrap;
  font-family: 'Quicksand';
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  -webkit-transition: background-color 0.15s ease,color 0.15s ease,width 0.3s ease,border 0.5s ease,border-color 0.5s ease,box-shadow 0.15s ease;
  transition: background-color 0.15s ease,color 0.15s ease,width 0.3s ease,border 0.5s ease,border-color 0.5s ease,box-shadow 0.15s ease;
  text-align: center;
  color: #FFFFFF;
  background-color: #5c078c;
  box-shadow: 0px 8px 24px rgba(0,0,0,0.1);
  ${FiraSansBold}
`;

export const Flag = styled.div`
  display: flex;
  width: 50px;
  height: 50px;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: flex-end;
  margin: 0px;
  padding: 0;
  margin-bottom: 20px;
`;

export const TotalContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const LabelGroup = styled.div`
  display: flex;
  flex-direction: column;

  width: ${({ width }) => width && `${width}`};

  ${mediaHelperMaxWidth.md`
    width: ${({ tabletWidth }) => tabletWidth && `${tabletWidth}` };
    min-width: ${({ tabletWidth }) => tabletWidth && `${tabletWidth}`};
  `}

  ${mediaHelperMaxWidth.sm`
    width: ${({ mobileWidth }) => mobileWidth && `${mobileWidth}` };
    min-width: ${({ mobileWidth }) => mobileWidth && `${mobileWidth}`};
  `}
`;